import type React from 'react';

import { Button, Chip, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useStateCodeFilter } from './hooks';

export const StateCodeFilter: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { hasSelectedFilters, visibleFilters, shouldShowToggle, showFullList },
		actions: { updateFilter, clearFilters, toggleList },
	} = useStateCodeFilter();

	return (
		<div data-testid="filter-list-section" className="space-y-4">
			<Text>
				<Translate value="corgi.location_page_sitemap.location_list.filter" />
			</Text>

			<ul className="flex flex-wrap gap-2">
				<li>
					<Chip
						active={!hasSelectedFilters}
						aria-pressed={!hasSelectedFilters}
						onClick={() => clearFilters()}
						size="small"
						data-qa="clear-filters"
					>
						{translate('corgi.topic_page_sitemap.topic_list.all_filter')}
					</Chip>
				</li>

				{visibleFilters.map((filter) => (
					<li key={filter.value}>
						<Chip
							active={filter.selected}
							aria-pressed={filter.selected}
							onClick={() => updateFilter(filter.value)}
							size="small"
							className="px-[10px]"
							data-qa={`filter-${filter.value}`}
						>
							{filter.name}
						</Chip>
					</li>
				))}
			</ul>

			{shouldShowToggle && (
				<Button
					aria-expanded={showFullList}
					size="small"
					variant="tertiary"
					className="text-typography-interactive p-0 hover:bg-transparent!"
					onClick={() => toggleList()}
					data-qa="show-full-list"
				>
					{showFullList
						? translate('corgi.location_page_sitemap.location_list.show_less')
						: translate('corgi.location_page_sitemap.location_list.show_full_list')}
				</Button>
			)}
		</div>
	);
};
